import { render, staticRenderFns } from "./VesselMonitoringSimpleFullHatch.vue?vue&type=template&id=ca3b8770&scoped=true"
import script from "./VesselMonitoringSimpleFullHatch.vue?vue&type=script&lang=ts"
export * from "./VesselMonitoringSimpleFullHatch.vue?vue&type=script&lang=ts"
import style0 from "./VesselMonitoringSimpleFullHatch.vue?vue&type=style&index=0&id=ca3b8770&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca3b8770",
  null
  
)

export default component.exports